<h3-view-settings-slider
  label="Opacity"
  [defaultValue]="defaultLayerOpacity"
  [settingName]="eventSettingName"
  [settingStore]="layerOpacityStore"
></h3-view-settings-slider>
